<template>
    <ReoDialog
        v-if="show"
        @cancel="$emit('update:show',false)"
        class="email-dialog"
        isBottomWhenMobile
    >
        <div class="dialog-content">
            <h3>{{ $t('cloud.verify.title') }}</h3>
            <ElInput
                v-model="emailAddress"
                disabled
            />
            <div class="input-container">
                <ElInput v-model.trim="code" :placeholder="$t('cloud.verify.code')" />
                <reo-common-button
                    :label="sendCodeButtonLabel"
                    :disabled="isSendCodeButtonDisabled"
                    :customWidth="140"
                    @click="handleSendCode"
                    class="send_btn"
                />
            </div>
            <div class="error" v-if="error">{{ error }}</div>
            <reo-common-button
                :label="$t('cancel_plan.confirm')"
                @click="handleConfirmCode"
                :disabled="!code || isDisabled"
            />
        </div>
    </ReoDialog>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoDialog from '@/basic/Dialog.vue';
import { Input as ElInput } from 'element-ui';
import { mapGetters } from 'vuex';
import user from '@/api/user';
import { getErrorSymbol } from '@/common/js/utils';
import reolinkGa from '@/common/js/gtagPageview';

export default Vue.extend({
    components: {
        ReoDialog,
        ElInput
    },
    model: {
        prop: 'show',
        event: 'update:show'
    },
    props: {
        show: Boolean,
        from: String
    },
    data() {

        return {
            code: '',
            seconds: 0,
            error: '',
            isDisabled: false
        };

    },
    computed: {
        ...mapGetters( ['emailAddress'] as const ),
        sendCodeButtonLabel(): string {

            return this.seconds > 0
                ? `${this.$t( 'mfa.resend_email_code_in' ).toString()} ${this.seconds}s`
                : this.$t( 'mfa.send_email_code' ) as string;

        },
        isSendCodeButtonDisabled(): boolean {

            return this.seconds > 0;

        }
    },
    watch: {
        show( val: boolean ) {

            if ( val ) {

                this.code = '';
                this.error = '';

            }

        }
    },
    methods: {
        secondsTimer(): void {

            this.seconds = 60;
            const timer = window.setInterval(() => {

                this.seconds--;
                if ( this.seconds === 0 ) {

                    clearInterval( timer );

                }

            }, 1000 );

        },
        async handleSendCode() {

            try {

                await user.createEmailVerifyMFACode();
                this.secondsTimer();

            } catch ( err ) {

                this.handleError( err );

            }

        },
        async handleConfirmCode() {

            try {

                if ( this.from === 'cloud-plan' ) {

                    reolinkGa.sendSimpleEvent( 'Cloud Storage Service-Email Verification' );

                }
                else if ( this.from === 'sim-plan' ) {

                    reolinkGa.sendSimpleEvent( 'sim list-Email Verification' );

                }
                this.isDisabled = true;
                await user.verifyEmailWithMFACode( this.code );
                this.$emit( 'update:show', false );
                this.$emit( 'verified' );

            } catch ( err ) {

                this.handleError( err );
                this.isDisabled = false;

            }

        },
        handleError( err: unknown ) {

            const symbol = getErrorSymbol( err );
            if ( this.$te( `errors.${symbol}` )) {

                this.error = this.$tc( `errors.${symbol}` );

            } else {

                this.error = this.$tc( 'errors.error_unknown' );

            }

        }
    }
});
</script>

<style lang="less" scoped>
.dialog-content{
    padding: 0 100px;
    width: 360px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    .mobile({
        width: 100%;
        padding: 0
    });
    .input-container{
        display: flex;
        gap: 12px;
        margin-top: -12px;
        align-items: center;
        .send_btn{
            flex-shrink: 0;
            /deep/ .reo-button-inner{
                padding: 12px;
            }
        }
    }
    .error{
        color: @red_5;
        font-size: 14px;
        text-align: left;
        margin: -12px 0;
    }
    h3{
        font-size: 24px;
        font-weight: 600;
        text-align: center;
        .mobile({
            font-size: 18px;
        });
    }
    /deep/ .el-input__inner{
        height: 53px;
        border-radius: @border-radius-level-button;
        &:focus{
            border-color: @b_6;
        }
    }
    /deep/ .el-input.is-disabled .el-input__inner{
        color: @font_tertiary;
        background-color: @fill_disable;
    }
}

.email-dialog{
    /deep/ .reo-dialog-inner{
        max-width: none !important;
    }
}
</style>
